// SEO インフルエンサージャンルページ(layouts/seo_layout で @seo_inline_contact のとき)専用のエントリー。
// ページ内問い合わせフォームに必要な JS だけを持つ(application.js は 5MB 超のため読まない)。
//   - Stimulus + recaptcha-v2 コントローラ(登録名は controllers/index.js と同じ)
//   - reCAPTCHA api.js の遅延読み込み
//   - フラッシュの自動非表示
//   - 共通ナビのモバイルメニュー(<details>)をページ内リンクで閉じる
import { application } from "./controllers/application"
import RecaptchaV2Controller from "./controllers/recaptcha_v2_controller"
import { setupLazyRecaptcha } from "./lib/lazy_recaptcha"
import { autoHideFlashMessages } from "./lib/flash_auto_hide"

application.register("recaptcha-v2", RecaptchaV2Controller)

// module スクリプトは HTML の解析後に実行されるため、ここでは DOM が揃っている
const recaptchaSrc = document.querySelector('meta[name="recaptcha-api-src"]')?.getAttribute("content")
setupLazyRecaptcha({ target: document.getElementById("contact"), src: recaptchaSrc })

autoHideFlashMessages()

// 共通ナビ(partials/navbar_landing)のモバイルメニューは <details> のため、ページ内リンク(#contact)を押すとページ遷移が無く開いたままになる。
// メニュー内のページ内リンクを押したらメニューを閉じる
document.querySelectorAll("header details").forEach((details) => {
  details.addEventListener("click", (event) => {
    if (event.target.closest('a[href^="#"]')) details.open = false
  })
})
